import { Pipe, PipeTransform } from '@angular/core';
import { parse } from 'ts-node';

@Pipe({
  name: 'strToNumber'
})
export class StringToInteger implements PipeTransform {

  transform(value: string,type:string) {
        let val:number;
        if(type=='float'){
            val = parseFloat(value);
        }else{
            val = parseInt(value);
        }
      return val;
  }

}
